import { InjectionToken } from '@angular/core';

export const BASE_PATH = new InjectionToken<string>('basePath');

export const LIGHT_PARTNER_API_PATH = new InjectionToken<string>('lightPartnerApiPath');
